import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { memo } from "react";

const Title = ({
  children,
  title,
  classNameBox,
  classNameTitle,
  classNameExtra,
}: {
  children?: any;
  title?: ReactJSXElement | string;
  classNameBox?: string;
  classNameTitle?: string;
  classNameExtra?: string;
}) => {
  return (
    <div className={`w-auto flex justify-between items-center text-center my-5 ${classNameBox || ""}`}>
      <div className={`font-bold flex flex-row text-3xl font-familyPoppins text-textPrimary ${classNameTitle || ""}`}>{title}</div>
      {children ? <div className={`flex flex-wrap space-x-3 font-normal ${classNameExtra || ""}`}>{children}</div> : ""}
    </div>
  );
};

export default memo(Title);
